/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_Audio_DescriptionInputs */



/**
* | output |
* | --- |
* | "Audio Description Settings" |
*
* @param {Ad_Section_Audio_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_audio_description = /** @type {((inputs?: Ad_Section_Audio_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_Audio_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres d'audiodescription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen für Audiodeskription")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni audiodescrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки тифлокомментария")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustes de audiodescripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("口述影像设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声解説の設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो विवरण सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Definições de audiodescrição")
	return /** @type {LocalizedString} */ ("Audio Description Settings")
});